import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Mic, Activity, Settings as SettingsIcon, Plus, History, Users, GraduationCap, BarChart3 } from "lucide-react";
import Jarvis from "@/pages/Jarvis";
import JarvisTelemetry from "@/pages/JarvisTelemetry";
import JarvisSettings from "@/pages/JarvisSettings";
import { JarvisPersonasTab } from "@/components/jarvis/JarvisPersonasTab";
import { JarvisTrainingTab } from "@/components/jarvis/JarvisTrainingTab";
import { JarvisObservabilityTab } from "@/components/jarvis/JarvisObservabilityTab";

type TabKey = "console" | "personas" | "training" | "observability" | "telemetry" | "settings";

const VALID: TabKey[] = ["console", "personas", "training", "observability", "telemetry", "settings"];

export default function JarvisHub() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const raw = (params.get("tab") || "console") as TabKey;
  const tab: TabKey = VALID.includes(raw) ? raw : "console";

  const setTab = (v: string) => {
    navigate(`/jarvis?tab=${v}`, { replace: true });
  };

  return (
    <div className="container mx-auto px-4 py-6 max-w-7xl">
      <div className="mb-4 flex items-center justify-between gap-3">
        <Tabs value={tab} onValueChange={setTab} className="w-auto overflow-x-auto">
          <TabsList className="inline-flex">
            <TabsTrigger value="console" className="gap-2"><Mic className="w-4 h-4" /> Console</TabsTrigger>
            <TabsTrigger value="personas" className="gap-2"><Users className="w-4 h-4" /> Personas</TabsTrigger>
            <TabsTrigger value="training" className="gap-2"><GraduationCap className="w-4 h-4" /> Treino</TabsTrigger>
            <TabsTrigger value="observability" className="gap-2"><BarChart3 className="w-4 h-4" /> Observabilidade</TabsTrigger>
            <TabsTrigger value="telemetry" className="gap-2"><Activity className="w-4 h-4" /> Telemetria</TabsTrigger>
            <TabsTrigger value="settings" className="gap-2"><SettingsIcon className="w-4 h-4" /> Configurações</TabsTrigger>
          </TabsList>
        </Tabs>
        <div className="flex items-center gap-2">
          <Button asChild variant="outline" size="sm">
            <Link to="/jarvis/history"><History className="w-4 h-4 mr-2" /> Histórico</Link>
          </Button>
          <Button asChild size="sm">
            <Link to="/jarvis/new"><Plus className="w-4 h-4 mr-2" /> Nova sessão</Link>
          </Button>
        </div>
      </div>

      <Tabs value={tab} onValueChange={setTab} className="w-full">
        <TabsContent value="console" className="mt-2"><Jarvis /></TabsContent>
        <TabsContent value="personas" className="mt-2"><JarvisPersonasTab /></TabsContent>
        <TabsContent value="training" className="mt-2"><JarvisTrainingTab /></TabsContent>
        <TabsContent value="observability" className="mt-2"><JarvisObservabilityTab /></TabsContent>
        <TabsContent value="telemetry" className="mt-2"><JarvisTelemetry /></TabsContent>
        <TabsContent value="settings" className="mt-2"><JarvisSettings /></TabsContent>
      </Tabs>
    </div>
  );
}
